module.exports = __webpack_public_path__ + "static/img/mediaCompany.e69d4fb5.png";